<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{ $t("esgPlatform.esgReport.esgReportBuilder") }}</h2>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mr-2 mb-2" @click="$router.push({ name: 'manageTemplate' })">
                    {{ $t("esgPlatform.esgReport.manageTemplates") }}
                </v-btn>
                <v-btn color="primary" dark class="mb-2" @click="$router.push({ name: 'createNewEsgReport' })">
                    {{ $t("esgPlatform.esgReport.createNewEsgReport") }}
                </v-btn>
            </div>

            <v-card elevation="0" class="px-5">
                <v-card-text>
                    <report-list class="mt-4" :toggleSelection="false" :toggleFilterState="false" />
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import ReportList from './components/report-list.vue';

export default {
    components: {
        ReportList,
    },
    data() {
        return {
            esgReports: [],
            breadcrumbs: [
                {
                    text: this.$t("esgPlatform.esgPlatform"),
                    disabled: false,
                    to: { name: "esg-dashboard" },
                    exact: true,
                },
                {
                    text: this.$t("esgPlatform.esgReport.esgReportBuilder"),
                    disabled: true,
                    href: "breadcrumbs_link_1",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header span {
    text-transform: uppercase !important;
    color: black;
}
</style>
